module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/自动上料+焊机+自动下料设备.a2bb113e.png";